import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import styles from '../styles/ServiceManager_old.module.css';

const serviceNames2 = {
  avitoPoolWorker: "Делит задания для статуса Avito",
  avitoGetWorker: "Получение статы из Avito",
  butch_to_google: "Стата и статус в Google",
  template_to_g: "Шаблон → Google",
  balance_report_av: "Баланс Avito",
  telegram: "Телеграм",
  excel_to_g: "Excel → Google",
  xml_to_avito: "пути к XML для Авито",
  video_servers_api: "Апи для видеоворкеров",
};

const serviceNames = {
  google_xml: "Создание XML из Google",
  googleStatusWorker: "Статус Google",
  googleStatusWorker2: "Статус Google2",
  googleStatusWorker3: "Статус Google3",
  quart_pool: "Гугл аккаунты",
  bd_queue: "Очередь БД",
  avitostavki: "Авито ставки",
  yandex_photo: "Яндекс фото",
  "new-five-ads": "Новый сайт БЭК",
};

const primaryActions = [
  { value: "logs", label: "Логи" },
  { value: "start", label: "▶" },
  { value: "stop", label: "■" },
  { value: "restart", label: "↻" }
];

const moreActions = [
  { value: "status", label: "ℹ" },
  { value: "enable", label: "Автозапуск" },
  { value: "disable", label: "✖ Автозапуск" }
];


export default function ServiceManager() {
  const [statuses, setStatuses] = useState({});
  const [outputLines, setOutputLines] = useState([]);
  const [visibleLines, setVisibleLines] = useState(1);
  const [outputHeight, setOutputHeight] = useState(260);
  const [error, setError] = useState("");
  const [currentService, setCurrentService] = useState("");
  const [isServicesCollapsed, setIsServicesCollapsed] = useState(false);
  const outputRef = useRef(null);

  const output = useMemo(() => {
    return outputLines.slice(-visibleLines).join("\n");
  }, [outputLines, visibleLines]);

  const requestStatusAll = () => {
    setError("");
    axios
      .get("/api/admin/status_all_old")
      .then((response) => {
        setStatuses(response?.data || {});
      })
      .catch((requestError) => {
        const message = requestError?.response?.data?.error || requestError?.message || "Ошибка запроса";
        setError(message);
        appendOutputLines(`❌ ${message}`);
      });
  };

  const stopLogs = () => {
    appendOutputLines("В классическом режиме live-логи не управляются отдельной командой");
  };

  const splitToLines = (text) => {
    return String(text || "")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "")
      .split("\n");
  };

  const appendOutputLines = (incoming) => {
    setOutputLines((prev) => {
      const next = [...prev, ...splitToLines(incoming)];
      return next.slice(-5000);
    });
  };

  const appendPayloadOutput = (payload) => {
    if (!payload) {
      appendOutputLines("Команда выполнена");
      return;
    }

    if (typeof payload === "string") {
      appendOutputLines(payload);
      return;
    }

    if (payload.error) {
      appendOutputLines(`❌ ${payload.error}`);
      return;
    }

    if (payload.result) {
      appendOutputLines(payload.result);
      return;
    }

    if (payload.output) {
      appendOutputLines(payload.output);
      return;
    }

    if (payload.message) {
      appendOutputLines(payload.message);
      return;
    }

    if (payload.status) {
      appendOutputLines(String(payload.status));
    }
  };

  const handleAction = (service, action) => {
    setCurrentService(service);
    if (action === "logs") {
      setOutputLines([]);
    }
    setError("");
    axios
      .post("/api/admin/service_old", { service, action })
      .then((response) => {
        const payload = response?.data;
        if (action === "status") {
          requestStatusAll();
        }

        appendPayloadOutput(payload);
      })
      .catch((requestError) => {
        const message = requestError?.response?.data?.error || requestError?.message || "Ошибка запроса";
        setError(message);
        appendOutputLines(`❌ ${message}`);
      });
  };

  useEffect(() => {
    requestStatusAll();
  }, []);

  useEffect(() => {
    const element = outputRef.current;
    if (!element) return undefined;

    const recalculateVisibleLines = () => {
      const computed = window.getComputedStyle(element);
      let lineHeight = Number.parseFloat(computed.lineHeight);
      if (Number.isNaN(lineHeight)) {
        const fontSize = Number.parseFloat(computed.fontSize) || 16;
        lineHeight = fontSize * 1.2;
      }

      const paddingTop = Number.parseFloat(computed.paddingTop) || 0;
      const paddingBottom = Number.parseFloat(computed.paddingBottom) || 0;
      const contentHeight = Math.max(0, element.clientHeight - paddingTop - paddingBottom);
      const byHeight = Math.floor(contentHeight / lineHeight);
      setVisibleLines(Math.max(1, byHeight));
    };

    const recalculateOutputHeight = () => {
      const rect = element.getBoundingClientRect();
      const bottomGap = 24;
      const nextHeight = Math.floor(window.innerHeight - rect.top - bottomGap);
      setOutputHeight(Math.max(140, nextHeight));
    };

    const recalculateAll = () => {
      recalculateOutputHeight();
      recalculateVisibleLines();
    };

    recalculateAll();

    const resizeObserver = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(recalculateAll)
      : null;

    if (resizeObserver) {
      resizeObserver.observe(element);
    }

    window.addEventListener("resize", recalculateAll);

    return () => {
      window.removeEventListener("resize", recalculateAll);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [isServicesCollapsed]);

  return (
    <div className={styles.super_container}>
  <div style={{ marginBottom: "5px" }}>
     <button
      className={styles.actionButton}
      onClick={() => setIsServicesCollapsed((prev) => !prev)}
    >
      {isServicesCollapsed ? "Развернуть службы" : "Свернуть службы"}
    </button>
    <button
      className={styles.actionButton}
      onClick={requestStatusAll}
    >
      Обновить статусы
    </button>
    <button
      className={styles.actionButton}
      onClick={stopLogs}
      style={{ marginLeft: "8px" }}
    >
      Остановить логи
    </button>
    <span style={{ marginLeft: "12px", color: "#0f5132" }}>
      Классический режим
    </span>
    {!!error && (
      <span style={{ marginLeft: "12px", color: "red" }}>
        ❌ {error}
      </span>
    )}
    <span style={{ marginLeft: "12px" }}>
      Влезает строк: {visibleLines}
    </span>
  </div>
 {!isServicesCollapsed && (
 <div className={styles.service_div}>
  <div className={styles.servicesContainer}>
    {Object.entries(serviceNames).map(([key, name]) => (
      <div key={key} className={styles.service}>
        <span className={styles.serviceName}>
          {name} ({key})
        </span>
        <span
          className={styles.serviceStatus}
          style={{ color: statuses[key] === "Запущено" ? "green" : "red" }}
        >
          {statuses[key] || "Загрузка..."}
        </span>
        {/* {actions.map(action => (
          <button
            key={action.value}
            onClick={() => handleAction(key, action.value)}
            className={styles.actionButton}
          >
            {action.label}
          </button>
        ))} */}
        {primaryActions.map(action => (
            <button
              key={action.value}
              onClick={() => handleAction(key, action.value)}
              className={styles.actionButton}
            >
              {action.label}
            </button>
          ))}

          <select
            className={`${styles.actionButton} ${styles.select_button}`}

            onChange={(e) => {
              if (e.target.value) {
                handleAction(key, e.target.value);
                e.target.selectedIndex = 0; // сброс
              }
            }}
          >
            <option value="">⚙ Ещё</option>
            {moreActions.map(action => (
              <option key={action.value} value={action.value}>
                {action.label}
              </option>
            ))}
          </select>

      </div>
    ))}
  </div>
  <div className={styles.servicesContainer}>
    {Object.entries(serviceNames2).map(([key, name]) => (
      <div key={key} className={styles.service}>
        <span className={styles.serviceName}>
          {name} ({key})
        </span>
        <span
          className={styles.serviceStatus}
          style={{ color: statuses[key] === "Запущено" ? "green" : "red" }}
        >
          {statuses[key] || "Загрузка..."}
        </span>
        {/* {actions.map(action => (
          <button
            key={action.value}
            onClick={() => handleAction(key, action.value)}
            className={styles.actionButton}
          >
            {action.label}
          </button>
        ))} */}
        {primaryActions.map(action => (
            <button
              key={action.value}
              onClick={() => handleAction(key, action.value)}
              className={styles.actionButton}
            >
              {action.label}
          </button>
        ))}

        <select
          className={`${styles.actionButton} ${styles.select_button}`}

          onChange={(e) => {
            if (e.target.value) {
              handleAction(key, e.target.value);
              e.target.selectedIndex = 0; // сброс
            }
          }}
        >
          <option value="">⚙ Ещё</option>
          {moreActions.map(action => (
            <option key={action.value} value={action.value}>
              {action.label}
            </option>
          ))}
        </select>

      </div>
    ))}
  </div>
  </div>
  )}
  <h3 className={styles.h2}>
  Результат{currentService ? `: ${serviceNames[currentService] || serviceNames2[currentService] || currentService}` : ""}
</h3>
      <pre ref={outputRef} style={{ background: "#f0f0f0", padding: "10px", whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere", margin: "0", minHeight: "140px", maxHeight: `${outputHeight}px`, height: `${outputHeight}px`, overflow: "auto" }}>
  {output}
</pre>
    </div>
  );
}
